import regionBasicInfoPanelTranslations from './RegionSection/RegionBasicInfoSection/translations';
import regionMapPanelTranslations from './RegionSection/RegionMapSection/translations';
import countryPanelTranslations from './CountrySection/translations';

export default {
    ...regionBasicInfoPanelTranslations,
    ...regionMapPanelTranslations,
    ...countryPanelTranslations,
};